<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
<div class="mb-2">
      <el-form inline ref="form" :model="searchform">
        <el-form-item class="mb-0">
             <el-select v-model="searchform.value1" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;" >
               <el-option
                      v-for="item in searchform.searchOptions1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        <el-form-item class="mb-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        

          <el-form-item class="mb-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:100px;"></el-input>
          </el-form-item>
          <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          </el-form-item>
      </el-form>
      
    </div>
	<div class="d-flex align-items-center flex-1112">
    <div>
      <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
    <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
		<el-button type="success" size="mini" @click="editContent(false)">{{$t('tableText.추가')}}</el-button> 
    
 </div>

		
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange" :row-style="tableRowClassName">
        <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
        <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*30-scope.$index}}</template>
        </el-table-column>


         <el-table-column  align="center" label="NID">

          <template  slot-scope="scope">   {{scope.row.sid}}</template>
        </el-table-column>
     
   <el-table-column
        
        :label="$t('tableText.알본사')" v-if="this.sitetype==4 && this.userid=='admin'" prop="admin_id" align="center">
         <template slot-scope="scope">
            {{scope.row.admin_id}}
          </template>
      </el-table-column> 

   <el-table-column
        
        label="도메인" prop="domain" align="center" >
        
      </el-table-column> 
      
       <el-table-column
        
        :label="$t('tableText.조회')" prop="visit" align="center" width="150">
         <template slot-scope="scope">
              <el-input
            type="text"
            v-model="scope.row.visit" @change="changeVisit(scope)">
          </el-input>
          </template>
      </el-table-column> 
     
      <el-table-column
        
        :label="$t('msg.제목')" prop="subject" align="center">
         <template slot-scope="scope">
              <el-button type="text" @click="editContent(scope)">{{scope.row.subject}}</el-button>
          </template>
      </el-table-column> 

        <el-table-column
        
        :label="$t('tableText.타입')" prop="m_name" align="center" >
        <template slot-scope="scope">
          {{mtype[scope.row.m_name]}}
        </template>
      </el-table-column>


       <el-table-column
        
        :label="$t('tableText.시간')" prop="stime" align="center" >
        
      </el-table-column> 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        <el-dialog
          :title="$t('status.편집')"
          :visible.sync="creatModel" :close-on-click-modal ="false" :width="boardW">

          <el-form ref="form" :model="form" label-width="60px" v-loading="loading" :rules="rules">
           <div class="d-flex" style="height:50px">
            <el-form-item :label="$t('msg.제목')" prop="subject" style="width: 50%;" class="mb-0">
            <div class="d-flex">
                 <el-input  v-model="form.subject" :placeholder="$t('msg.제목입력')"></el-input><el-input v-model="form.stime" :class="this.editIndex ===-1 ?'d-none' :'d-block'" class="ml-2 mr-2" style="width: 150px;"></el-input>
             </div>    
                
            </el-form-item>
            <el-form-item v-if="this.sitetype==4 && this.userid=='admin'" class="mb-0">
              <span class="mr-2" style="margin-left:-40px">{{$t('status.알본선택')}}</span>
               <el-select v-model="form.admin_id"  style="width: 80px;" class="mr-2">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="mb-0">
               <el-select v-model="form.m_name" :placeholder="$t('searchText.타입선택')" style="width:90px;margin-left: -40px;" class="mr-2" >

               <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item>
                <span class="mr-2" style="margin-left:-40px">{{$t('searchText.상위노출')}}</span>
               <el-checkbox true-label="1" false-label="0" v-model="form.stick"></el-checkbox>
            </el-form-item>
          </div>
            <el-form-item label="도메인"  class="mb-0">
               <el-input  v-model="form.domain" style="width:85%"></el-input>
                <el-tooltip class="item" effect="dark" :content="$t('msg.여러도메인경우콤마로연결해주세요')" placement="right-end">
              <el-button icon="el-icon-warning" circle></el-button>
             </el-tooltip>
            </el-form-item>
           <el-form-item :label="$t('msg.내용')"  prop="content">
            <!-- 富文本编辑器 -->  
            
           
                      <quill-editor 
                                v-model="form.content" 
                                ref="myQuillEditor" 
                                :options="editorOption" 
                                @blur="onEditorBlur($event)" 
                                @focus="onEditorFocus($event)"
                              @change="onEditorChange($event)">
                      </quill-editor>
                      <input type="file" @change="change" id="upload" style="display:none;" />


              <!--  <mavon-editor
                    
                      placeholder="편집"
                       ref="editor"
                      v-model="form.content"
                      @imgAdd="imgAdd"
                      @change="change"
                     
                       :subfield="true"
                      :defaultOpen="'preview'"
                      :preview="true"

                     >
                   </mavon-editor> -->
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
				
</div>
 </template>

 <script>
import { quillEditor, Quill  } from "vue-quill-editor";
Quill.register('modules/ImageExtend', ImageExtend)
import {ImageExtend, QuillWatch } from "quill-image-extend-module"
import "quill/dist/quill.core.css"; 
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
      
    export default {
     components: {
      quillEditor,
      
    },
    	data(){
    		return{
          boardW:'850px',
          pictureUrl: '',
         uploadFileData: null,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
            userid:window.sessionStorage.getItem('userid'),
           editorOption: {
           
            modules:{
            
              toolbar: {
                container:[
                     ['bold', 'italic', 'underline', 'strike'],  
                   
                     [{'list': 'ordered'}, {'list': 'bullet'}], 
                     ["image",'video','link'],
                     [{'color': []}, {'background': []}],
                    
                     [{'header': [1, 2, 3, 4, 5, 6, false]}],
                     
                ],
                 handlers: {
                    image(value) {
                      if (value) {
                        
                        document.querySelector('#upload').click()
                      } else {
                        this.quill.format('image', false)
                      }
                    },
                  },

              },
            },
             
            },

          adminlist:[{
                label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
             bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
          html:'',
          otp:'',
          mtype:{"g_g4":this.$i18n.t("nav.공지사항"),"g_g3":this.$i18n.t("nav.변동정보"),"c_n":"예상정보","event":this.$i18n.t("nav.이벤트"),"faq":"FAQ"},
          typeOptions:[
                
            {
              label:this.$i18n.t("nav.공지사항"),
              value:'g_g4'
            }

            ],
            headers:{ 'Authorization': 'Bearer ' + window.sessionStorage.getItem('user') },
          
    		  form:{
            subject:'',
            content:'',
            m_name:'',
            stime:'',
            sid:'',
            stick:'',
            admin_id:'',
            domain:'',
          },
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		          label:this.$i18n.t("msg.제목"),
		        	value:'subject'
		        },
            

		        ],
		       searchOptions1:[
                
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
             {
              label:this.$i18n.t("nav.공지사항"),
              value:'g_g4'
            },
             {
              label:this.$i18n.t("nav.이벤트"),
              value:'event'
            },
             {
              label:'FAQ',
              value:'faq'
            }

            ],
            
            
		        value:'',
            value1:'',
          

      


    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
               upLoadUrl:'',
               rules: {

                //  admin_id:[{ required: true, message: '', trigger: 'blur'}],
                  m_name:[{ required: true, message: '', trigger: 'blur'}],
                  subject:[{ required: true, message: '', trigger: 'blur'}],
                  content:[{ required: true, message: '', trigger: 'blur'}],
                },
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
           
    			if(this.sitetype=="2" || this.sitetype=="3")
          {
              this.value1='g_g4';
              this.typeOptions=[
                {
                  label:this.$i18n.t("nav.공지사항"),
                  value:'g_g4'
                },
                 {
                  label:this.$i18n.t("nav.변동정보"),
                  value:'g_g3'
                }
                
              ];

              this.searchOptions1=[
                 {
                   label:this.$i18n.t("msg.전체"),
                   value:''
                 },
                 {
                   label:this.$i18n.t("nav.공지사항"),
                   value:'g_g4'
                 },
                 {
                   label:this.$i18n.t("nav.변동정보"),
                   value:'g_g3'
                 }
                
              ];
         }else if(this.sitetype=="4")
         {
              this.typeOptions=[
               {
                  label:this.$i18n.t("nav.공지사항"),
                  value:'g_g4'
                },
                {
                  label:this.$i18n.t("nav.이벤트"),
                  value:'event'
                },
                {
                  label:'FAQ',
                  value:'faq'
                }
                
              ];

              this.searchOptions1=[
                {
                   label:this.$i18n.t("msg.전체"),
                   value:''
                 },
                 {
                    label:this.$i18n.t("nav.공지사항"),
                   value:'g_g4'
                 },
                 {
                   label:this.$i18n.t("nav.이벤트"),
                   value:'event'
                 },
                 {
                   label:'FAQ',
                   value:'faq'
                 }
                
              ];
         }else
         {

         }

    			this.getList();
    			
			
		},
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
    }
  },
    	methods:{
        change(e) {
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    console.log('url:',url.data.data)
                     const quill = this.$refs.myQuillEditor.quill
                      quill.focus()
                      quill.insertEmbed(quill.getSelection().index, 'image', url.data.data)
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },

          onEditorReady(editor) { // 准备编辑器
        },
          onEditorBlur(){}, // 失去焦点事件
          onEditorFocus(){}, // 获得焦点事件
          onEditorChange(event){
              // console.log(event.html)
               this.form.content = event.html
          }, // 内容改变事件
   
  


    //     change(value, render) {
    //   // render 为 markdown 解析后的结果
    //   this.html = render;
    // },

        　// 绑定@imgAdd event
　　　　　　imgAdd(pos, $file){
            
             const isLt2M = $file.size / 1024 / 1024 < 2;

              
              if (!isLt2M) {
                this.$message.error(this.$i18n.t("msg.크기보다작아야함"));
                this.$refs.editor.$img2Url(pos,"");
                return;
              }


             let token=window.sessionStorage.getItem('user');
       
　　　　　　　　// 第一步.图片上传到服务器.
　　　　　　　　var formdata = new FormData();
　　　　　　　　formdata.append('file', $file);
　　　　　　　　this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formdata,
　　　　　　　　　
　　　　　　　　}).then((url) => {
　　　　　　　　　　// 第二步.将返回的url替换到文本原位置![...](0) -> ![...](url)
　　　　　　　　　 // console.log('url',url);
　　　　　　　　　　this.$refs.editor.$img2Url(pos, url.data.data);
　　　　　　　　})
　　　　　　},
        tableRowClassName({row, rowIndex}) {
            let rowbackgroundbg = {};
            if(row.stick == '1'){
              rowbackgroundbg.background = '#ebeef5';
              return rowbackgroundbg;
            }
      },
    
        editContent(e = false){
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })
          //tianjia
          if(!e){
            this.form = {
   
                content:'',
                subject:'',
                domain:'',
                stime:''
                 }
             this.editIndex = -1

          }
          else{
             //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/board?id='+e.row.sid,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 

              
                  this.loading = false
                  let item = response.data.data
                 // console.log('data==',item)

                 this.typevalue=item.m_name
                  
                    this.form = {
                          sid:item.sid,
                          subject:item.subject,
                           domain:item.domain,
                           m_name:item.m_name,
                            stick:item.stick,
                          content:item.content,
                          stime:item.stime,
                          admin_id:item.admin_id

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })


          }
        
          this.creatModel = true
         
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              this.currentPage=1;
            


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		  // console.log(this.searchform.value) 
            //   console.log(this.searchform.keyword) 
            //   console.log(this.searchform.time) 
             

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/boardlist?type='+this.searchform.value1+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('tableData=',response.data.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		changeVisit(e){
              let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/board_up',
                      data:{  
                            visit:e.row.visit,

                            id:e.row.sid
                      },
                            
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                   if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                    }
                    else{
                      this.$message({
                        message:this.$i18n.t("msg.완료"),
                        type:'success'
                    })    
                    }         
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
        },
    		  submit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/board_insert',
                        data:{
                          content:this.form.content,
                          id:this.form.sid,
                          m_name:this.form.m_name,
                          subject:this.form.subject,
                           domain:this.form.domain,
                          stime:this.form.stime,
                           stick:this.form.stick,
                           admin_id:this.form.admin_id
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message.error({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(this.$i18n.t("msg.완료"));
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                     this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{

              //console.log(this.html)
              //return;
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/board_up',
                      data:{
                          content:this.form.content,
                          id:this.form.sid,
                          subject:this.form.subject,
                          domain:this.form.domain,
                          m_name:this.form.m_name,
                          stime:this.form.stime,
                          stick:this.form.stick,
                          admin_id:this.form.admin_id
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })  
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
    	handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
        // 批量删除
      deleteAll(){
         this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.sid);
           });

          // console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/board_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		
    	}
  }
</script>

 <style scoped>
>>>.el-table  tr.el-table__row:hover td.el-table__cell{
  background: none !important;
}
>>>.ql-editor{
  height: 300px;
}
>>>.ql-snow .ql-picker{
  height: auto;
}
  @media (max-width: 1112px){
      .flex-1112{
        flex-direction: column;
        align-items: normal !important;

      }
      .ml-1112{
        margin-right: auto !important;
      }
    }
     >>>.el-button.is-circle{
      padding: 3px;
    background: transparent;
    border: none;
    color: #000 !important;font-size: 24px !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/board/list.vue